
import { at } from 'lodash';
import { useField, Form, FormikProps, Formik } from 'formik';
import TextField from '@mui/material/TextField';

export default function TextAreaField(props:any) {

    
  const { errorText, ...rest } = props;
  const [field, meta, isdisabled] = useField(props);
  


  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
   
    if (touched && error) {
        return error;
    }
  }

  return (
    <TextField
      multiline
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      rows={5}
    />
  );
}